




























import * as api from '@/api';

export default {
    props: ['fileTypes', 'dialogVisible'],
    data() {
        return {
            selectedTypeIndex: 0,
            selectedFile: (this as any).fileTypes[0],
            loading: false as boolean,
        };
    },
    computed: {
        currentProductInfo(): any {
            return (this as any).$store.state.currentProductInfo;
        },
    },
    methods: {
        downKit() {
            const origin = process.env.NODE_ENV === 'dev' ? process.env.VUE_APP_BASEURL : window.location.origin;
            window.open(`${origin}/ibuildingkit/download/iBuildingKit.zip`);
        },
        selectFileType(item, index) {
            (this as any).selectedFile = item;
            (this as any).selectedTypeIndex = index;
        },
        async downloadModelFile() {
            (this as any).loading = true;
            const getSignedUrl: any = await api.getSignedUrl({
                extensionName: (this as any).selectedFile.extensionName,
                pvId: (this as any).currentProductInfo.pvId,
                productId: (this as any).currentProductInfo.id,
            });
            if (!api.error(getSignedUrl)) {
                window.location.href = getSignedUrl.data.url;
                setTimeout(() => {
                    (this as any).$emit('downLoadSuccess', true);
                }, 600);
            } else {
                (this as any).$message({
                    type: 'error',
                    message: getSignedUrl.error.message,
                });
            }
            (this as any).loading = false;
        },
    },
};
